import * as React from 'react';
import { DistributionType } from '../../../models';
import { SingleLink } from './SingleLink';
import { Unique } from './Unique';
import { SSO } from './SSO';
import { IApplicationState } from '../../../store';
import { useSelector } from 'react-redux';
import { SingleLinkWithoutDistribution } from './SingleLinkWithoutDistribution';

export const DistributionNotificationRouter = () => {
	const { distributionType } = useSelector((state: IApplicationState) => state.audienceDetails.audience);

	switch (distributionType) {
		case DistributionType.SingleLink:
		case DistributionType.SingleLinkWithAccessCode:
			return <SingleLink />;
		case DistributionType.SingleLinkWithoutDistribution:
			return <SingleLinkWithoutDistribution />;
		case DistributionType.Unique:
			return <Unique />;
		case DistributionType.SSO:
			return <SSO />;
		default:
			return <></>;
	}
};
